import { createSlice } from "@reduxjs/toolkit";
import {
  genInfoKeys,
  identities,
  address,
  // contact,
  contract,
  payment,
  eligibility,
  salary,
  dependents,
  attendance,
} from "../../utils/form-keys";
const initialState = {
  ...genInfoKeys,
  ...identities,
  ...payment,
  ...address,
  // ...contact,
  ...contract,
  ...eligibility,
  ...salary,
  annual_leave_policy: [],
  ...dependents,
  ...attendance,
};

const employeeFormSlice = createSlice({
  name: "employeeForm",
  initialState,
  reducers: {
    updateField: (state, action) => {
      const { name, value } = action.payload;
      state[name] = value;
    },
    resetForm: () => initialState,
  },
});

export const { updateField, resetForm } = employeeFormSlice.actions;
export default employeeFormSlice.reducer;
